import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputBox from "../../../components/input-box";
import { createShopifyCollection } from "../../../services/axios";
import { storeKeys } from "../../campaigns/components/requests/stores";

export default function CreateStoreCollectionModal({
  salesforce_id,
  visible,
  setVisible,
}: {
  salesforce_id: string;
  visible: boolean;
  setVisible: (value: boolean) => void;
}) {
  let [loading, setLoading] = useState(false);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      description: "",
      store: "athletesthread",
      type: "",
      segement: "",
      organization_name: "",
      college_name: "",
      athlete_name: "",
      sports: "",
      account_name: "",
    },
    validationSchema: Yup.object({
      title: Yup.string().min(1).max(200).required("Required"),
      description: Yup.string().min(1).max(500).required("Required"),
      store: Yup.string().min(1).max(200).required("Required"),
      type: Yup.string().min(1).max(200).required("Required"),
      segement: Yup.string().min(1).max(200).required("Required"),
      organization_name: Yup.string().min(1).max(200).required("Required"),
      college_name: Yup.string().min(1).max(200).required("Required"),
      athlete_name: Yup.string().min(1).max(200).required("Required"),
      sports: Yup.string().min(1).max(200).required("Required"),
      account_name: Yup.string().min(1).max(200).required("Required"),
    }),
    onSubmit: async (formData) => {
      try {
        console.log("formData", formData);
        setLoading(true);
        const createNewCollection = await createShopifyCollection(
          `${salesforce_id}-${formData.store}`,
          formData.title,
          formData.description,
          salesforce_id,
          formData.store,
          formData.type,
          formData.segement,
          formData.organization_name,
          formData.college_name,
          formData.athlete_name,
          formData.sports,
          formData.account_name
        );
        console.log("created new shopify collection", createNewCollection);
        setLoading(false);
        setVisible(false);
      } catch (e: any) {
        console.log("ERORR", e);
      }
    },
  });

  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={visible} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={setVisible}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title
                      as="h3"
                      className="text-lg leading-6 font-medium text-gray-900"
                    >
                      Add a new Store Collection
                    </Dialog.Title>
                    <div className="my-2 mb-4">
                      <p className="text-sm text-gray-500">
                        Add a new store collection to your organization
                      </p>
                    </div>
                    <div className="mt-2 w-full">
                      <InputBox
                        type="text"
                        placeholder="Title"
                        label="Title"
                        name={formik.getFieldProps("title").name}
                        value={formik.getFieldProps("title").value}
                        onChange={formik.getFieldProps("title").onChange}
                        onBlur={formik.getFieldProps("title").onBlur}
                        touched={formik.touched.title}
                        error={formik.errors.title}
                      />
                      <InputBox
                        type="text"
                        placeholder="Description"
                        label="Description"
                        name={formik.getFieldProps("description").name}
                        value={formik.getFieldProps("description").value}
                        onChange={formik.getFieldProps("description").onChange}
                        onBlur={formik.getFieldProps("description").onBlur}
                        touched={formik.touched.description}
                        error={formik.errors.description}
                      />
                      <div className="mb-4">
                        <label
                          htmlFor="store"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Store
                        </label>
                        <select
                          id="store"
                          name={formik.getFieldProps("store").name}
                          className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                          value={formik.getFieldProps("store").value || ""}
                          onChange={formik.getFieldProps("store").onChange}
                          onBlur={formik.getFieldProps("store").onBlur}
                        >
                          {storeKeys.map((store) => {
                            return <option key={store.id}>{store.id}</option>;
                          })}
                        </select>
                      </div>
                      <div className="mb-4">
                        <label
                          htmlFor="store"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Metafield - Type
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <select
                            id={formik.getFieldProps("type").name}
                            name={formik.getFieldProps("type").name}
                            autoComplete={formik.getFieldProps("type").name}
                            value={formik.getFieldProps("type").value}
                            onChange={formik.getFieldProps("type").onChange}
                            className="w-full border-r border-gray-300 py-2 focus:ring-indigo-500 focus:border-indigo-500 h-full pl-3 pr-7 bg-gray-50 text-gray-500 sm:text-sm rounded-md"
                          >
                            <option value="none" disabled hidden>
                              Select a Type
                            </option>
                            {[
                              "None",
                              "Other",
                              "National Organization",
                              "College",
                              "Official Sports",
                              "Local Organization",
                            ].map(function (item, index) {
                              return (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>
                      <div className="mb-4">
                        <label
                          htmlFor="store"
                          className="block text-sm font-medium text-gray-700"
                        >
                          Metafield - Segment
                        </label>
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <select
                            id={formik.getFieldProps("segement").name}
                            name={formik.getFieldProps("segement").name}
                            autoComplete={formik.getFieldProps("segement").name}
                            value={formik.getFieldProps("segement").value}
                            onChange={formik.getFieldProps("segement").onChange}
                            className="w-full border-r border-gray-300 py-2 focus:ring-indigo-500 focus:border-indigo-500 h-full pl-3 pr-7 bg-gray-50 text-gray-500 sm:text-sm rounded-md"
                          >
                            <option value="none" disabled hidden>
                              Select a Category
                            </option>
                            {[
                              "None",
                              "Other",
                              "College",
                              "Panhellenic",
                              "IFC",
                              "Multicultural Greeks",
                              "NPHC",
                              "Pre-Professional",
                              "Official Sports",
                              "Student Organization",
                              "Club Sports",
                              "Program",
                              "Department",
                              "Dance Marathon",
                              "Alumni Associations",
                            ].map(function (item, index) {
                              return (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <InputBox
                            type="text"
                            placeholder="Organization Name"
                            label="Organization Name"
                            name={
                              formik.getFieldProps("organization_name").name
                            }
                            value={
                              formik.getFieldProps("organization_name").value
                            }
                            onChange={
                              formik.getFieldProps("organization_name").onChange
                            }
                            onBlur={
                              formik.getFieldProps("organization_name").onBlur
                            }
                            touched={formik.touched.organization_name}
                            error={formik.errors.organization_name}
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <InputBox
                            type="text"
                            placeholder="College Name"
                            label="College Name"
                            name={formik.getFieldProps("college_name").name}
                            value={formik.getFieldProps("college_name").value}
                            onChange={
                              formik.getFieldProps("college_name").onChange
                            }
                            onBlur={formik.getFieldProps("college_name").onBlur}
                            touched={formik.touched.college_name}
                            error={formik.errors.college_name}
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <InputBox
                            type="text"
                            placeholder="Athlete Name"
                            label="Athlete Name"
                            name={formik.getFieldProps("athlete_name").name}
                            value={formik.getFieldProps("athlete_name").value}
                            onChange={
                              formik.getFieldProps("athlete_name").onChange
                            }
                            onBlur={formik.getFieldProps("athlete_name").onBlur}
                            touched={formik.touched.athlete_name}
                            error={formik.errors.athlete_name}
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <InputBox
                            type="text"
                            placeholder="Sport"
                            label="Sport"
                            name={formik.getFieldProps("sports").name}
                            value={formik.getFieldProps("sports").value}
                            onChange={formik.getFieldProps("sports").onChange}
                            onBlur={formik.getFieldProps("sports").onBlur}
                            touched={formik.touched.sports}
                            error={formik.errors.sports}
                          />
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="mt-1 relative rounded-md shadow-sm">
                          <InputBox
                            type="text"
                            placeholder="Account Name"
                            label="Account Name"
                            name={formik.getFieldProps("account_name").name}
                            value={formik.getFieldProps("account_name").value}
                            onChange={
                              formik.getFieldProps("account_name").onChange
                            }
                            onBlur={formik.getFieldProps("account_name").onBlur}
                            touched={formik.touched.account_name}
                            error={formik.errors.account_name}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                {!loading ? (
                  <>
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={formik.submitForm}
                    >
                      Create
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={() => setVisible(false)}
                      ref={cancelButtonRef}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <p className="text-sm text-gray-900">Loading</p>
                )}
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
